import React from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";

/**
 * Единый переключатель-«пилюли»: фильтры и табы внутри страницы.
 * Заменяет локальные наборы .pd-tag, .pd-tags, .plan-view-switch__btn,
 * .chat-tabs__btn, .anketa-lang-btn.
 *
 * <SegmentedControl
 *   value={activeTab}
 *   onChange={setActiveTab}
 *   items={[{ value: "all", label: "Все" }, { value: "uzi", label: "УЗИ" }]}
 * />
 *
 * tone="primary"  — активный тёмно-синий (по умолчанию, как было в списках)
 * tone="accent"   — активный жёлтый (как табы в шапке карточки пациента)
 * size="sm" | "md"
 * joined — слитный переключатель: кнопки вплотную, скруглены только края
 * mobileSelect — на мобильных вместо кнопок показывать выпадающий список
 */
const SegmentedControl = ({
    value,
    onChange,
    items = [],
    tone = "primary",
    size = "sm",
    joined = false,
    mobileSelect = false,
    ariaLabel,
    className,
}) => {
    const isMobile = useMediaQuery("(max-width: 991px)");

    const classes = [
        "ui-segment",
        `ui-segment--${tone}`,
        `ui-segment--${size}`,
        joined && "ui-segment--joined",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    // Мобильный вариант: компактный выпадающий список вместо ряда кнопок.
    if (mobileSelect && isMobile) {
        return (
            <div className={`ui-segment-select ui-segment-select--${size}`}>
                <select
                    aria-label={ariaLabel}
                    className="ui-segment-select__control"
                    value={value ?? ""}
                    onChange={(event) => onChange?.(event.target.value)}>
                    {items.map((item) => {
                        const itemValue = item.value ?? item.key;
                        return (
                            <option key={itemValue} value={itemValue}>
                                {item.label}
                            </option>
                        );
                    })}
                </select>
                <span
                    className="ui-segment-select__chev"
                    aria-hidden="true"
                />
            </div>
        );
    }

    return (
        <div
            aria-label={ariaLabel}
            className={classes}
            role="tablist">
            {items.map((item) => {
                const itemValue = item.value ?? item.key;
                const isActive = itemValue === value;
                return (
                    <button
                        key={itemValue}
                        aria-selected={isActive}
                        className={`ui-segment__btn${
                            isActive ? " is-active" : ""
                        }`}
                        role="tab"
                        type="button"
                        onClick={() => onChange?.(itemValue)}>
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedControl;
